import { createContext, useCallback, useContext, useRef, useState } from 'react'
import type { ReactNode } from 'react'
import { Toast } from '../ds'

type ToastKind = 'ok' | 'error'

interface ToastApi {
  notify: (text: string, kind?: ToastKind) => void
}

const ToastContext = createContext<ToastApi>({ notify: () => {} })

export function useToast(): ToastApi {
  return useContext(ToastContext)
}

// Унифицированный текст ошибки из любого исключения (ApiError несёт message).
export function errorText(error: unknown): string {
  return error instanceof Error && error.message ? error.message : 'Что-то пошло не так'
}

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toast, setToast] = useState<{ id: number; text: string; kind: ToastKind } | null>(null)
  const counter = useRef(0)
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  const notify = useCallback((text: string, kind: ToastKind = 'ok') => {
    const id = (counter.current += 1)
    setToast({ id, text, kind })
    if (timer.current) {
      clearTimeout(timer.current)
    }
    timer.current = setTimeout(() => {
      setToast((current) => (current && current.id === id ? null : current))
    }, 3200)
  }, [])

  return (
    <ToastContext.Provider value={{ notify }}>
      {children}
      {toast && <Toast kind={toast.kind}>{toast.text}</Toast>}
    </ToastContext.Provider>
  )
}
